














import Vue from "vue";

export default Vue.extend<{}, {}, {}, Props>({
  props: {
    iconSize: {
      type: Number,
      default: 24,
    },
    fill: {
      type: String,
      default: "#d0d0d0",
    },
    onClick: Function,
    item: Object,
  },
});

interface Props {
  iconSize: number;
  fill: string;
  item: any;
  onClick: (item: any) => void;
}
